<script lang="ts">
	import { goto, pushState } from '$app/navigation';
	import { page } from '$app/stores';
	import BottomDrawer from '@components/global/mobile/BottomDrawer.svelte';
	import MediaQuery from 'svelte-media-queries';
	import ChevronExpand from 'virtual:icons/ion/chevron-expand';
	import Select from '@components/global/Select.svelte';
	import { isLockScroll } from '@lib/stores/main-layout.store';

	export let sortOptions = [
			{ label: 'Terbaru', value: 'newest' },
			{ label: 'Terlama', value: 'oldest' },
			{ label: 'Harga Terendah', value: 'min_price' },
			{ label: 'Harga Tertinggi', value: 'max_price' }
		],
		paramName = 'sort_by';

	let activeSort = '';

	const params = {
		sortBy: $page.url.searchParams.get(paramName) ?? sortOptions[0].value.split('-')[0]
	};

	// Adjust initial load params from url
	activeSort = params.sortBy;

	const handleSortButton = () => pushState('', { showDrawer: true });
	const handleSortInput = (value: string) => handleSort(value);

	function handleSort(value: string) {
		activeSort = value;

		const currentUrl = $page.url;
		currentUrl.searchParams.set(paramName, value);

		goto(currentUrl, { invalidateAll: true, replaceState: true });
	}

	$: activeLabel = sortOptions.find((option) => option.value === activeSort)?.label ?? 'Urutkan';
	$: $isLockScroll = !!$page.state.showDrawer;
</script>

<button
	on:click|stopPropagation={handleSortButton}
	type="button"
	class="btn btn-outline btn-accent btn-sm flex items-center gap-2 rounded-full lg:hidden"
>
	<ChevronExpand class="text-xl" />
	{activeLabel}
</button>

<MediaQuery query="(min-width: 1024px)" let:matches>
	{#if matches}
		<Select
			options={sortOptions}
			on:change={({ detail }) => handleSortInput(detail.value)}
			bind:selectedValue={activeSort}
		/>
	{:else if $page.state.showDrawer}
		<BottomDrawer
			on:clickoutside={() => history.back()}
			on:close={() => history.back()}
			title="Urutkan"
		>
			<div>
				{#each sortOptions as option}
					<label class="flex items-center justify-between gap-2.5 border-b py-4">
						<span>{option.label}</span>
						<input
							on:change={() => handleSortInput(option.value)}
							type="radio"
							name="radio-10"
							class="radio checked:radio-secondary"
							value={option.value}
							bind:group={activeSort}
						/>
					</label>
				{/each}
			</div>
		</BottomDrawer>
	{/if}
</MediaQuery>
